import Head from "next/head";
import Appbar from "../components/appBar";
import Footer from "../components/footer";
import Grid from "@material-ui/core/Grid";
import MarkdownPost from "../components/markdown"; 
import WidgetWa from "../components/widgetWa"; 
import matter from 'gray-matter'; 

export default function Policy({ data }) {

  return (
    <>
      <Head>
        <title>Políticas</title>
        <link rel="icon" href="/favicon.ico" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta itemProp="description" content="Conozca las políticas que CIDU S.A.S. emplea para un exelente desempeño y labor que usted necesita."/>
        <link rel="canonical" href="https://cidu.com.co/policy" />
      </Head>

      <Grid>
        <Appbar />
        <MarkdownPost data={data}/> 
        <Footer/>
      </Grid>
      <WidgetWa link={"https://wa.me/573014606980/?text=Hola%20CIDU,%20quiero%20contactarme%20con%20Ustedes!"}/>
    </>
  );
}
 
export async function getStaticProps() {
  const fileContent = await import("../posts/policy.md")
  const data = matter(fileContent.default);
  const json = JSON.parse(JSON.stringify(data));
  return {
    props: {
      data: json
    }
  }
}
 
 
